import { INSIGHTS_PANEL, VIEW_SETTINGS_PANEL } from '../../../model/panels/constants.tsx';
import type { State } from '../../types.tsx';

export const getPanels = (state: State) => state.ui.panels;

export const getInsightsPanel = (state: State) => state.ui.panels?.[INSIGHTS_PANEL] || false;

export const getViewSettingsPanel = (state: State) =>
	state.ui.panels?.[VIEW_SETTINGS_PANEL] || false;
